import React, { useState, useEffect } from 'react';
import { Col, Row, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

//Routes
import routes from '../../routes';

//Components
import MainCard from '../../components/MainCard/MainCard';
import Loading from '../../components/Loading/Loading';

//Api
import acesso_api from '../../api/acesso_api';

//Helpers
import { getSessionCookie } from '../../helpers/cookies';
import { showMessage } from '../../helpers/message';

//Assets
import "../../assets/css/relatorios.css"

export default function Relatorios() {
    //Variavel utilizada para navegação nas telas
    const navigate = useNavigate();
    //Usuario logado no sistema
    const usuario = getSessionCookie();
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);
    //Estado que guarda os relatorios disponiveis para serem listados
    const [relatorios, setRelatorios] = useState([]);
    useEffect(() => {
        setLoading(true);
        acesso_api.getFuncionalidadesRelatorios(usuario.acesso.sigla).then(response => {
            //pegando os relatorios que são fixos para o modulo
            const relatoriosFixos = routes.filter(route =>
                route.codigoFuncionalidade &&
                route.codigoFuncionalidade.split(".")[0] === "Relatorios" &&
                route.modulo &&
                route.modulo.indexOf(usuario.acesso.modulo) != -1 &&
                !route.layoutRelatorio
            );
            
            //Adicionando os relatorios fixos aos relatorios que serão listados
            relatoriosFixos.map(value => {
                const novoRelatorio = {
                    descricao: value.name,
                    funcao: value.codigoFuncionalidade,
                }
                response.data.push(novoRelatorio);
            });

            //informando a ação do botão do relatorio
            response.data = response.data.map(value => {

                const rota = routes.filter(route => route.codigoFuncionalidade === value.funcao);
                if (rota.length > 0) {
                    value.onClick = () => {
                        navigate(rota[0].layout + "/" + rota[0].path)
                    };
                }
                return value;
            });

            setRelatorios(response.data.filter((value, index, self) => index === self.findIndex(relatorio => relatorio.descricao === value.descricao)));
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }, []);
    return (
        <MainCard noCard>
            {loading && <Loading />}
            <Row>
                {
                    relatorios.map(value => {
                        return (
                            <>
                                <Col className='p-2' sm="12" md="6" lg="4">
                                    <div className='bg-light mt-2 rounded-3 w-100 h-100 shadow d-flex align-items-start justify-content-between flex-column'>
                                        <h5 className='ps-3 pt-3 pb-2'>{value.descricao}</h5>
                                        <div className='w-100 d-flex align-items-center justify-content-end pe-3 pt-3 pb-3'>
                                            <Button color='warning text-light' style={{ fontWeight: "600" }} onClick={() => value?.onClick()}>VISUALIZAR RELATÓRIO</Button>
                                        </div>
                                    </div>
                                </Col>
                            </>
                        );
                    })
                }
            </Row>
        </MainCard>
    )
}